var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    x: 0,
    y: 0,
    width: 16,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H16V12H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98013 0.868168V3.45966C8.98013 3.53316 8.94759 3.60632 8.89177 3.65849C8.83595 3.71066 8.75722 3.74116 8.67813 3.74149C6.02866 3.75449 3.9921 4.49949 2.62409 5.84815C1.50099 6.95531 0.816622 8.4843 0.648075 10.3995C1.30044 9.3038 2.08736 8.48347 3.11609 7.91364C4.49301 7.15098 6.26811 6.84598 8.67649 6.84598C8.75613 6.84598 8.83504 6.87631 8.89122 6.92848C8.9474 6.98081 8.98013 7.05414 8.98013 7.12798V9.9663L15.2054 5.46148L8.98013 0.868168ZM8.8654 0.0631708L15.8855 5.24282C15.9569 5.29565 16.0004 5.37982 16 5.46482C15.9995 5.54965 15.9553 5.63348 15.8833 5.68565L8.86304 10.7655C8.64631 10.9158 8.38595 10.7535 8.37286 10.5433V7.41231C6.18084 7.43764 4.61319 7.74064 3.42719 8.39764C2.19154 9.08197 1.33426 10.159 0.59753 11.8043C0.434619 12.1285 0.0164348 12.0201 0.0046165 11.6971C-0.0666567 9.06547 0.688621 6.93414 2.18209 5.46165C3.62573 4.03832 5.74175 3.25066 8.37286 3.18266V0.284003C8.38976 0.0010044 8.66068 -0.066162 8.8654 0.0631708V0.0631708Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.5b3c2be7d134a8bba5b33c5f77a6b771.svg";
export { ForwardRef as ReactComponent };